import {VUwebSearchService} from '@/shared/services/azure-search-service';
import {Config} from './config-viewmodel';
import {Person} from './person-viewmodel';

export interface IPeopleSearchWidgetState {
    config: Config,
    loading: boolean,
    error: string,
    azureService: VUwebSearchService,
    searchQuery: string,
    totalResults: number,
    results: Person[],
    currentPage: number
}

export default class PeopleSearchWidgetState implements IPeopleSearchWidgetState {
    config: Config = {
        language: '',
        index: '',
        resultsPerPage: 10,
        resultsOrder: '',
        endpoint: undefined,
        labels: {}
    };
    innerLoading = true;
    loading = true;
    error = '';
    azureService = new VUwebSearchService('');
    searchQuery = '';
    totalResults = 0;
    results: Person[] = [];
    currentPage = 0;
}
